"use client";

import { Check, UserCheck, Link2, FilePen as FileEdit } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Ketentuanklarifikasi() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const capabilities = [{
    number: "1",
    title: "Diverifikasi",
    description: "Setiap permohonan klarifikasi akan melalui proses verifikasi data dan fakta yang ketat oleh tim redaksi kami.",
    Icon: Check
  }, {
    number: "2",
    title: "Identitas Jelas",
    description: "Pemohon wajib melampirkan identitas diri yang sah dan memiliki hubungan langsung dengan materi pemberitaan.",
    Icon: UserCheck
  }, {
    number: "3",
    title: "Tautan Berita Terkait",
    description: "Menyertakan tautan (URL) berita yang ingin diklarifikasi untuk mempermudah proses peninjauan kembali.",
    Icon: Link2
  }, {
    number: "4",
    title: "Penyuntingan Teknis",
    description: "Redaksi berhak melakukan penyuntingan teknis tanpa mengubah substansi klarifikasi yang disampaikan.",
    Icon: FileEdit
  }];
  return <section data-section-id="4553" id="ketentuanklarifikasi" className="bg-white text-black py-16 md:py-24 px-4 sm:px-6 lg:px-10">
      <div className="max-w-7xl mx-auto">
        <div ref={headerRef} className={`grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 mb-12 md:mb-16 transition-all duration-700 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="lg:col-span-5">
            <p className="font-default text-xs tracking-widest uppercase text-orange-600 mb-4">
              03 / Ketentuan Klarifikasi
            </p>
            <h2 className="font-default font-bold text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight text-black">
              Klarifikasi Resmi & Hak Jawab.
            </h2>
          </div>
          <div className="lg:col-span-7 lg:pl-8 flex items-end">
            <p className="font-default text-base leading-relaxed text-gray-600 max-w-2xl">
              Kami berkomitmen menjaga integritas jurnalistik melalui proses verifikasi yang ketat. Setiap informasi yang kami sajikan didasarkan pada fakta, dan kami menyediakan ruang bagi pihak terkait untuk memberikan klarifikasi demi kebenaran informasi.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
          {capabilities.map((cap, i) => {
          const Icon = cap.Icon;
          return <div data-index={i} key={cap.number} className="group relative bg-white border border-gray-100 shadow-sm hover:shadow-md transition-all duration-300 p-6 flex flex-col rounded-lg">
                <div className="flex items-start gap-4 mb-4">
                  <div className="shrink-0">
                    <Icon strokeWidth={2} className="size-6 text-orange-600" />
                  </div>
                  <div>
                    <h3 className="font-default font-bold text-base leading-tight text-black">
                      {cap.number}. {cap.title}
                    </h3>
                  </div>
                </div>

                <p className="font-default text-sm leading-relaxed text-gray-600 mb-4">
                  {cap.description}
                </p>

                <div className="mt-auto pt-2">
                  <Link to="/ClarificationPage" className="inline-flex items-center gap-2 font-default text-[10px] tracking-widest uppercase text-gray-400 group-hover:text-orange-600 transition-colors duration-300">
                    <span className="relative">
                      <span className="bg-left-bottom bg-gradient-to-r from-orange-600 to-orange-600 bg-[length:0%_1px] bg-no-repeat group-hover:bg-[length:100%_1px] transition-[background-size] duration-500 ease-out pb-0.5">
                        Selengkapnya
                      </span>
                    </span>
                    <span aria-hidden="true">→</span>
                  </Link>
                </div>
              </div>;
        })}
        </div>

        <div className="mt-12 md:mt-16 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6 pt-8 border-t border-gray-100">
          <div className="max-w-xl">
            <p className="font-default text-sm text-gray-600">
              Hubungi tim redaksi kami untuk pengajuan hak jawab atau klarifikasi resmi terkait pemberitaan <span className="font-bold text-black">ABADI.NEWS</span>.
            </p>
          </div>
          <Button asChild size="lg" className="bg-orange-600 text-white hover:bg-orange-700 font-default text-xs tracking-widest uppercase rounded-md px-8">
            <Link to="/ContactPage">Ajukan Klarifikasi</Link>
          </Button>
        </div>
      </div>
    </section>;
}